import i18n from "i18next";

import { initReactI18next } from "react-i18next";

// Import translation files
import components from "assets/locales/en/components.json";
import error from "assets/locales/en/error.json";
import general from "assets/locales/en/general.json";
import login from "assets/locales/en/login.json";
import home from "assets/locales/en/home.json";
import jobDetails from "assets/locales/en/jobDetails.json";
import admin from "assets/locales/en/admin.json";
import sharing from "assets/locales/en/sharing.json";
import notFound from "assets/locales/en/notFound.json";

const namespacesToPreload: string[] = ["general", "components"];

i18n.use(initReactI18next).init({
  fallbackLng: ["en"],
  debug: false,
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      components,
      error,
      general,
      login,
      home,
      jobDetails,
      admin,
      sharing,
      notFound,
    },
  },
  lng: "en", // default language
  ns: namespacesToPreload,
  defaultNS: "general",
});

export default i18n;
